import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const inventoryApi = createApi({
  reducerPath: 'inventoryApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getProductStockSummary: builder.query({
      query: (productId) => ({
        url: '/inventories/summary',
        method: 'GET',
        params: { product_id: productId },
      }),
    }),
  }),
});

export const { useLazyGetProductStockSummaryQuery } = inventoryApi;
